<template>
  <button
    :title="title"
    :tabindex="-1"
    class="custom-editor__button heading-level heading-level-3"
    :class="[
      { 'is-active': isActive ? isActive() : null },
      type ? `custom-editor__button_${type}` : ''
    ]"
    type="button"
    @click.prevent="action"
  >
    <icon
      :data="icon"
      width="1em"
      height="1em"
    />
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Icon } from "@yzfe/vue3-svgicon"

import { CallbackFunction } from "@/models"

@Options({
  name: "EditorMenuItem"
})
export default class EditorMenuItem extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  readonly icon: Icon
  @Prop({
    type: String,
    required: true
  })
  readonly title: string
  @Prop({
    type: Function,
    required: true
  })
  action: CallbackFunction
  @Prop({
    type: Function,
    default: null
  })
  isActive: CallbackFunction
  @Prop({
    default: ""
  })
  type: string
}
</script>
